import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import DocumentModal from "../Client-Info/DocumentModel2";
import {
  FaFile,
  FaFilePdf,
  FaFileImage,
  FaFileWord,
  FaFileExcel,
  FaFileAlt,
  FaFileArchive,
  FaFileVideo,
  FaFileAudio,
  FaFileCode,
  FaExclamationTriangle,
  FaEye,
  FaTrashAlt,
} from "react-icons/fa";
import config from "../../Common/Configurations/APIConfig";

export default function File() {
  const { folderId } = useParams();
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [documentModalVisible, setDocumentModalVisible] = useState({
    visible: false,
    serviceTaskId: null,
    clientId: null,
    folderId: null,
  });
  const [serviceTaskId, setServiceTaskId] = useState(null);
  const [clientId, setClientId] = useState(null);
  const headerconfig = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("userToken"),
    },
  };
  useEffect(() => {
    GetFilesByFolderId();
    GetServiceTaskByFolderId();
  }, [folderId]);

  const GetFilesByFolderId = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        config.APIACTIVATEURL +
          config.GETFILESBYFOLDERID +
          "?folderId=" +
          folderId,
        {
          ...headerconfig,
        }
      );

      if (response.data.statusCode === 200) {
        const fileData = response.data.data?.data;
        setFiles(Array.isArray(fileData) ? fileData : []);
      } else {
        setError("Error fetching files.");
      }
    } catch (error) {
      setError("Error fetching files: " + error.message);
    } finally {
      setLoading(false);
    }
  };
  const GetServiceTaskByFolderId = async () => {
    try {
      const response = await axios.get(
        config.APIACTIVATEURL +
          config.GETSERVICETASKBYFOLDERID +
          "?folderId=" +
          folderId,
        {
          ...headerconfig,
        }
      );

      if (response.data.statusCode === 200) {
        setServiceTaskId(
          response.data.data.serviceTaskId ||
            "00000000-0000-0000-0000-000000000000"
        );
        setClientId(
          response.data.data.clientId || "00000000-0000-0000-0000-000000000000"
        );
      }
    } catch (error) {
      console.error("Error fetching service task: ", error);
    }
  };

  const getFileIcon = (fileName) => {
    const extension = fileName.split(".").pop().toLowerCase();

    switch (extension) {
      case "pdf":
        return <FaFilePdf size={40} color="#d9534f" />;
      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
        return <FaFileImage size={40} color="#5bc0de" />;
      case "doc":
      case "docx":
        return <FaFileWord size={40} color="#0275d8" />;
      case "xls":
      case "xlsx":
        return <FaFileExcel size={40} color="#5cb85c" />;
      case "zip":
      case "rar":
        return <FaFileArchive size={40} color="#f0ad4e" />;
      case "mp4":
      case "mov":
      case "avi":
        return <FaFileVideo size={40} color="#6610f2" />;
      case "mp3":
      case "wav":
        return <FaFileAudio size={40} color="#fd7e14" />;
      case "html":
      case "css":
      case "js":
      case "json":
        return <FaFileCode size={40} color="#6c757d" />;
      case "txt":
        return <FaFileAlt size={40} color="#343a40" />;
      default:
        return <FaFile size={40} color="#007bff" />;
    }
  };

  const handleViewDocument = (imageSrc) => {
    window.open(imageSrc, "_blank");
  };

  const handleDeleteDocument = async (documentId) => {
    try {
      await axios.delete(
        config.APIACTIVATEURL + config.DELETEDOCUMENT + "/" + documentId,
        {
          ...headerconfig,
        }
      );

      setFiles(files.filter((file) => file.documentId !== documentId));
    } catch (error) {
      alert("Error deleting file: " + error.message);
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setShowDropdown(e.target.value.length > 0);
  };

  const handleDropdownClick = (fileName) => {
    setSearchTerm(fileName);
    setShowDropdown(false);
  };

  const filteredFiles = searchTerm
    ? files.filter((file) =>
        file.documentName.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : files;

  return (
    <div id="layout-wrapper">
      <LayoutHeader />
      <LayoutSideBar />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-flex align-items-center justify-content-between">
                  <h4 className="mb-0">Files</h4>
                  <div className="d-flex align-items-center gap-2">
                    <button
                      className="btn btn-success"
                      onClick={() => {
                        setDocumentModalVisible({
                          visible: true,
                          serviceTaskId:
                            serviceTaskId ||
                            "00000000-0000-0000-0000-000000000000",
                          clientId:
                            clientId || "00000000-0000-0000-0000-000000000000",
                          folderId: folderId,
                        });
                      }}
                    >
                      Add File
                    </button>
                    <Link to={"/clientfolder"} className="btn btn-secondary">
                      Back
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-xl-12">
                <div className="card card-height-100">
                  <div className="card-header align-items-center d-flex">
                    <h4 className="card-title mb-0 flex-grow-1">Files</h4>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      {error ? (
                        <div className="alert alert-danger">
                          <FaExclamationTriangle className="me-2" />
                          {error}
                        </div>
                      ) : filteredFiles.length === 0 ? (
                        <p colSpan="6" className="text-center">
                          No files available .
                        </p>
                      ) : (
                        <div className="row">
                          {filteredFiles.map((file, index) => (
                            <div
                              key={file.fileId || index}
                              className="col-lg-3 col-md-4 col-sm-6 mb-4"
                              style={{ cursor: "pointer" }}
                            >
                              <div className="card text-center shadow-sm">
                                <div className="card-body">
                                  <div className="file-icon mb-3">
                                    {getFileIcon(
                                      file.imageName || file.documentName
                                    )}
                                  </div>
                                  <div className="file-name text-truncate">
                                    {file.documentName}
                                  </div>
                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                    <FaEye
                                      size={10}
                                      color="#343434"
                                      title="View Document"
                                      onClick={() =>
                                        handleViewDocument(file.imageSrc)
                                      }
                                      style={{ cursor: "pointer" }}
                                    />
                                    <FaTrashAlt
                                      size={10}
                                      color="#343434"
                                      title="Delete Document"
                                      onClick={() =>
                                        handleDeleteDocument(file.documentId)
                                      }
                                      style={{ cursor: "pointer" }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {console.log("ServiceTaskID:", documentModalVisible.serviceTaskId)}

            {documentModalVisible.visible && (
              <DocumentModal
                visible={documentModalVisible.visible}
                onClose={() => {
                  setDocumentModalVisible({
                    ...documentModalVisible,
                    visible: false,
                  });
                  GetFilesByFolderId();
                }}
                serviceTaskId={documentModalVisible.serviceTaskId}
                clientId={documentModalVisible.clientId}
                folderId={documentModalVisible.folderId}
                headerconfig={{
                  headers: {
                    Authorization:
                      "Bearer " + localStorage.getItem("userToken"),
                  },
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
